<template>
  <div
    class="dialog-heading q-py-sm text-bold relative-position"
    :class="containerClasses"
    :style="{'z-index': zIndex}"
  >
    <slot />
  </div>
</template>

<script>
import { stickyClasses, stickyValidator } from 'src/helpers/sticky'

/**
 * List header which can be stuck to the top of its outer container
 *
 * SLOTS:
 * - default: Any content to display inside header
 */
export default {
  props: {
    // Container anchor (either: none [disable sticky], dialog(-menubar) [parent is a dialog], page(-menubar) [parent is a page]
    anchor: {
      type: String,
      validator: stickyValidator,
      default: 'dialog'
    },
    // Disable the sticky attribute - will not remain stuck at top of container when scrolling
    static: {
      type: Boolean,
      default: false
    },
    // Text color of content
    color: {
      type: String,
      default: 'clickable'
    },
    // Remove default padding from header
    withoutPadding: {
      type: Boolean,
      default: false
    },
    // Remove border from bottom of container
    withoutBorder: {
      type: Boolean,
      default: false
    },
    // Remove blur effect
    backgroundColor: {
      type: String,
      default: null
    },
    zIndex: {
      type: Number,
      default: undefined
    }
  },
  computed: {
    containerClasses () {
      return {
        ...stickyClasses(this.static ? false : this.anchor, !this.backgroundColor ? 'blurred-container' : `bg-${this.backgroundColor}`),
        ['text-' + this.color]: !!this.color,
        'no-border': this.withoutBorder,
        'q-px-md': !this.withoutPadding
      }
    }
  }
}
</script>
